// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const Pin = t.struct({
    account: t.String,
    createdBy: t.String,
    createdDate: t.maybe(t.Number),
    failureDate: t.maybe(t.Number),
    invoiceDate: t.maybe(t.Number),
    invoiceNumber: t.String,
    pin: t.String
}, {
    name: 'Pin',
    strict: true
});

export const getDefaultState = () => new Pin({
    account: '',
    createdBy: '',
    createdDate: null,
    failureDate: null,
    invoiceDate: null,
    invoiceNumber: '',
    pin: ''
});

export default Pin;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/pin.js